module.exports = __webpack_public_path__ + "static/media/circle_blue.5458a37a.svg";